<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-text>
          <div class="drag-line">
            <v-flex xs24 sm12 md8>
              <v-text-field
                id="drag-input"
                v-model="offset"
                type="number"
                :label="`${$t('drag_to_middle_dialog.from_end')}:`"
              ></v-text-field>
            </v-flex>
            <div class="center-button">
              <v-icon v-tooltip="$t('drag_to_middle_dialog.center')" large @click="center">format_align_center</v-icon>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="save">{{$t('drag_to_middle_dialog.confirm')}}</v-btn>
          <v-btn color="primary" flat @click="dialog = false">{{$t('drag_to_middle_dialog.cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Helper from "@/models/Helper.js";
export default {
  data() {
    return {
      dialog: false,
      offset: 0,
      pallet: null,
      stack: null,
      onKeyUp: e => {
        if (e.key === "Enter") {
          this.save();
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },

  methods: {
    async open(pallet, stack) {
      this.pallet = pallet;
      this.stack = stack;
      this.dialog = true;
      await Helper.timeout(50);
      document.getElementById("drag-input").focus();
      if (this.offset == 0) {
        this.center();
      }
    },

    center() {
      const palletMiddle = Math.round(
        (this.pallet.length * this.pallet.divider) / 2
      );
      const stackMiddle = Math.round(
        (this.pallet.divider * this.stack.getWidth()) / 2
      );
      this.offset = palletMiddle - stackMiddle;
    },

    async save() {
      this.stack.updateCoordinates(
        this.offset / this.pallet.divider,
        this.stack.y
      );
      await this.pallet.saveChanges();
      this.$emit("productUpdated");
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.drag-line {
  position: relative;
  width: 100%;
}
.center-button {
  position: absolute;
  right: 20px;
  top: 0;
}
</style>